import { FormHelpText, Stack, TextField } from '@drycut/ui-components';
import { Controller, type RegisterOptions } from 'react-hook-form';

type ControlledTextFieldProps = React.ComponentPropsWithRef<typeof TextField> & {
  label: string;
  loading?: boolean;
  name: string;
  onChange?: (value: React.ChangeEvent<HTMLInputElement>) => void;
  rules?: Omit<RegisterOptions, 'disabled' | 'setValueAs' | 'valueAsDate' | 'valueAsNumber'>;
};

export function ControlledTextField({
  name,
  label,
  loading = false,
  rules = {},
  onChange,
  ...props
}: ControlledTextFieldProps): React.ReactElement {
  const completeRules = { required: props.required ? 'Das darf nicht leer sein' : false, ...rules };

  return (
    <Controller
      name={name}
      rules={completeRules}
      render={({ field, fieldState: { invalid, error } }) => (
        <Stack gap={1} className="relative">
          <TextField
            {...field}
            onChange={(value) => {
              field.onChange(value);
              onChange?.(value);
            }}
            {...props}
            loading={loading}
            label={label}
            invalid={invalid}
          />

          {error && <FormHelpText error={invalid}>{error.message}</FormHelpText>}
        </Stack>
      )}
    />
  );
}
